import { ProjectUserRole_TransitionsGeneratedEntity } from "./generated/ProjectUserRole_TransitionsGeneratedEntity";

export abstract class ProjectUserRole_TransitionsEntity extends ProjectUserRole_TransitionsGeneratedEntity {
    // Comment to preserve new line
}
